import { DeterministicView } from '@bingads-webui/deterministic-view';
import _ from 'underscore';
import template from './header-template.pug';


/**
 * View class for Hotel Ads setup wizard header
 * @extends Backbone.View
 */
export class HeaderView extends DeterministicView {
  initialize(options) {
    this.options = options;
    this.i18n = options.i18n;
    this.model.on('change:step', (vm, value) => {
      this.trigger('step-changed', value);
    });
  }

  get template() {
    return template;
  }

  setState({ step }) {
    if (_.has(this.options.steps, step)) {
      this.model.set({ step });
    }
  }
}
